module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/1@2x_4e4a634a1d4dec85770cedba5f50f24b.png";